import React from 'react';
import { useQuery } from '@apollo/client';

import { formatDueCount, SidebarCountPill } from './FollowUpsDueBadge';
import { CRM_MATCH_REVIEW_WAITING } from './matchReview/matchReview.queries';

/**
 * How many NationBuilder records wait for a person (card 23): beside the
 * sidebar's Match Review entry, or on the CRM heading while it is collapsed.
 *
 * As the follow-ups count: read once per page load (Apollo answers each new
 * mount from its cache, the query having no variables), never on a timer, and
 * shown only when above zero. Hidden on any error too: a database without the
 * NationBuilder archive answers CRM_UNAVAILABLE, and a failed count must not
 * look like "none waiting". A review evicts `nbMatchReviewQueue`, so the count
 * asks again where it is shown.
 */
export const MatchReviewWaitingBadge = () => {
  const { data } = useQuery(CRM_MATCH_REVIEW_WAITING);
  const total: number | undefined = data?.nbMatchReviewQueue?.total;

  if (!total) return null;

  return (
    <SidebarCountPill
      aria-label={`${total.toLocaleString('en-US')} match${total === 1 ? '' : 'es'} waiting for review`}
      title={`${total.toLocaleString('en-US')} waiting`}
    >
      {formatDueCount(total)}
    </SidebarCountPill>
  );
};
